<template>
  <div
    class="basic-day--wrapper"
    :class="{
      'selected': isSelected,
      'selected--first': isFirstSelected,
      'selected--last': isLastSelected,
      'selected--in-range': inRange,
      'disabled': isDisabled,
      'first-of-month': firstOfMonth,
      'last-of-month': lastOfMonth,
      'first-of-week': firstOfWeek,
      'last-of-week': lastOfWeek,
    }"
  >
    <div class="basic-day--wrapper--box">
      <div
        class="basic-day--content"
      >
        <span class="basic-day--day">
          <slot />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isSelected: {
      type: Boolean,
      default: false,
    },
    isFirstSelected: {
      type: Boolean,
      default: false,
    },
    isLastSelected: {
      type: Boolean,
      default: false,
    },
    inRange: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    firstOfMonth: {
      type: Boolean,
      default: false,
    },
    lastOfMonth: {
      type: Boolean,
      default: false,
    },
    firstOfWeek: {
      type: Boolean,
      default: false,
    },
    lastOfWeek: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.basic-day {
  &--wrapper {
    @apply w-full mb-1 text-sm text-base-900 cursor-pointer;

    &.selected { @apply rounded-full; }
    &.selected--first { @apply rounded-l-full; }
    &.selected--last { @apply rounded-r-full; }

    &.selected,
    &.selected--first,
    &.selected--last {
      @apply bg-primary-300 bg-opacity-50;
      .basic-day--content {
        @apply text-primary-300 bg-primary-500 font-semibold;
      }
    }

    &.selected--in-range { @apply bg-primary-300 bg-opacity-50 text-primary-500; }
    &.disabled { @apply text-base-400 pointer-events-none; }

    &.first-of-week,
    &.first-of-month { @apply rounded-l-full; }
    &.last-of-week,
    &.last-of-month { @apply rounded-r-full; }

    &:hover:not(.selected--first):not(.selected--last) {
      .basic-day--content {
        @apply border border-primary-900;
      }
    }
  }
  &--wrapper--box {
    width: 100%;
    padding-bottom: 100%;
    height: 0;
    position: relative;

    .basic-day--content {
      @apply w-full h-full top-0 left-0 absolute flex justify-center items-center rounded-full;
    }
  }
}
</style>
